import React from 'react';
import { IconProps } from '.';

const SvgArrowTriangleDown = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M12 16 5 8h14l-7 8Z' />
    </svg>
  );
};

export default SvgArrowTriangleDown;
